import React, { useEffect, useState } from 'react';
import { Card, Spinner, Button, Collapse } from 'react-bootstrap';

const Bulletin = () => {
  const [items, setItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);

 const SHEET_JSON_URL =
  'https://opensheet.vercel.app/1Q8ez8uSQNua0DK5sNKvrLpjECzxqdAfZ-ALJIAnN5w8/Sheet1';


    

  useEffect(() => {
    fetch(SHEET_JSON_URL)
      .then((res) => res.json())
      .then((data) => {
        const sorted = data.sort((a, b) => new Date(b.Date) - new Date(a.Date));
        setItems(sorted);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error loading sheet:', error);
        setLoading(false);
      });
  }, []);

  const handleToggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="scroll-section" id="museum-bulletin">
      <h2 className="cta-2 mb-4">Bulletin</h2>

      <Card className="p-3">
        <h4 className="mb-3">Latest Announcements</h4>

        {loading ? (
          <div className="text-center">
            <Spinner animation="border" size="sm" /> Loading...
          </div>
        ) : (
          <div className="d-flex flex-column gap-2">
            {items.map((item, index) => (
              <div key={index}>
                <Button
  variant="outline-primary"
  className="text-start d-flex justify-content-between align-items-center"
  onClick={() => handleToggle(index)}
>
  <span>{item.Title}</span>
  <span className="ms-3">{item.Date}</span>
</Button>


                <Collapse in={activeIndex === index}>
                  <div className="mt-2 border p-3 rounded bg-light">
                    <p>{item.Content}</p>

                    {item['PDF Link']?.startsWith('http') && (
                      <a
                        href={item['PDF Link'].replace('/view', '/preview')}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-primary"
                      >
                        🔎 Preview PDF
                      </a>
                    )}

                    <p className="text-muted mt-2">Updated on: {item.Date}</p>
                  </div>
                </Collapse>
              </div>
            ))}
          </div>
        )}
      </Card>
    </section>
  );
};

export default Bulletin; 